export default __webpack_public_path__ + "static/persona_card-82c18c9ba060fbe27e849c445ee94e80.png";